import { render, staticRenderFns } from "./sidebarMenu.vue?vue&type=template&id=c1e73fa4"
import script from "./sidebarMenu.vue?vue&type=script&lang=js"
export * from "./sidebarMenu.vue?vue&type=script&lang=js"
import style0 from "./sidebarMenu.vue?vue&type=style&index=0&id=c1e73fa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports